/**
 * Per-step layout: heading + optional description + body (form fields + AI panel).
 */
export default function StepShell({ heading, description, children }) {
  return (
    <div className="space-y-2">
      <h2 className="text-xl font-semibold text-[#30302F] dark:text-white">{heading}</h2>
      {description && (
        <p className="text-sm text-[#30302F]/70 dark:text-white/70">{description}</p>
      )}
      <div className="pt-2">{children}</div>
    </div>
  );
}
